import {
  AddressAutocompleteDetailsContract,
  AddressAutocompleteResponseMatch,
  IAddressAutocompleteService,
} from '../../types/AddressValidation';
import { AddressAutocompleteServiceConfig } from '../../types/ServiceConfigurations';
import { Endpoints } from '../../utils/constants';

type AddressAutocompleteResponseBody = {
  matches?: AddressAutocompleteResponseMatch[];
};
type AddressAutocompleteDetailsResponseBody = {
  placeId: string;
  address1: string;
  locality: string;
  administrativeArea: string;
  subAdministrativeArea: string;
  postalCode: string;
  country: string;
};

class AddressAutocompleteService implements IAddressAutocompleteService {
  private apiUrl: string;

  private components = '';

  constructor(config: AddressAutocompleteServiceConfig) {
    this.apiUrl = config.apiUrl;
  }

  public getMatches = async (
    address1: string
  ): Promise<AddressAutocompleteResponseMatch[]> => {
    try {
      const response = await fetch(
        `${this.apiUrl}${
          Endpoints.AUTOCOMPLETE_MATCHES
        }?input=${encodeURIComponent(address1)}&components=${this.components}`,
        {
          method: 'GET',
        }
      );
      if (response.ok) {
        const result: AddressAutocompleteResponseBody = await response.json();
        return result.matches ?? [];
      }
    } catch (error) {
      // TODO friction or error logging can go here if needed
      // eslint-disable-next-line no-console
      console.error(error);
    }
    return [];
  };

  public getDetails = async (
    placeId: string
  ): Promise<AddressAutocompleteDetailsContract | null> => {
    try {
      const response = await fetch(
        `${this.apiUrl}${
          Endpoints.AUTOCOMPLETE_DETAILS
        }?placeId=${encodeURIComponent(placeId)}`,
        {
          method: 'GET',
        }
      );
      if (response.ok) {
        const result: AddressAutocompleteDetailsResponseBody =
          await response.json();
        return {
          address1: result.address1,
          city: result.locality,
          state: result.administrativeArea,
          country: result.country,
          postalCode: result.postalCode,
        };
      }
    } catch (error) {
      // TODO friction or error logging can go here if needed
      // eslint-disable-next-line no-console
      console.error(error);
    }
    return null;
  };

  public setComponents = (components: string): void => {
    this.components = components;
  };
}

export default AddressAutocompleteService;
